<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">Orders</h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 p-0">
        <li class="breadcrumb-item d-inline-block position-relative">
            <a routerLink="/dashboard" class="d-inline-block position-relative">
                <i class="material-symbols-outlined">home</i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item d-inline-block position-relative">Orders</li>
        <li class="breadcrumb-item d-inline-block position-relative">Order List</li>
    </ol>
</div>

<!-- Status Quick-Filter Pills -->
<div class="order-status-filters mb-25">
    <button
        class="status-pill"
        [class.active]="activeStatusFilter === null"
        (click)="filterByStatus(null)"
    >
        <i class="material-symbols-outlined">list</i>
        All Orders
        <span class="pill-count" *ngIf="activeStatusFilter === null">{{ totalRecords }}</span>
    </button>

    <button
        *ngFor="let s of allStatuses"
        class="status-pill status-pill--{{ s.cssKey }}"
        [class.active]="activeStatusFilter === s.value"
        (click)="filterByStatus(s.value)"
    >
        {{ s.label }}
    </button>
</div>

<!-- Order List Card -->
<div class="crm-leads-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none">
    <div class="trezo-card-header d-sm-flex align-items-center justify-content-between">
        <div class="trezo-card-title">
            <h5 class="mb-0">
                Order List
                <span class="total-badge ms-2">{{ totalRecords }} orders</span>
            </h5>
            <p class="mb-0 mt-1 text-muted small" *ngIf="activeStatusFilter">
                Showing: <strong>{{ activeStatusFilter }}</strong> orders
            </p>
        </div>
        <div class="trezo-card-subtitle">
            <button
                *ngIf="activeStatusFilter"
                class="clear-filter-btn"
                type="button"
                (click)="filterByStatus(null)"
            >
                <i class="material-symbols-outlined">filter_alt_off</i>
                Clear Filter
            </button>
        </div>
    </div>

    <div class="trezo-card-content">
        <app-table
            [datasource$]="orderService.data$"
            [columns]="columns"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [actionButtons]="actions"
            [sortable]="true"
            [usePagination]="true"
            [useFilter]="false"
            [queryParameters]="searchOptions"
            [resultLength]="totalRecords"
            [useStickyHeaders]="false"
            [allowRowSelection]="false"
            [allowDragDrop]="false"
            (eventHandler)="tableEvent($event)"
        >
        </app-table>
    </div>
</div>

<!-- Order Detail Side Panel -->
<div class="add-new-popup style-two" [class.active]="classApplied">
    <app-order-detail
        *ngIf="classApplied"
        [orderId]="selectedOrderId"
        (classApplied)="classAppliedEvent($event)"
        (statusUpdated)="refreshList()"
    />
</div>
